export default __webpack_public_path__ + "static/media/celebrating.2d1dffe5.png";